// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./subscribe.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var checkbox = require("../checkbox/checkbox");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).subscribe;
var parsing = require('parsing').subscribe;

function parse(text, next) {
    strip(require('raw!./subscribe.html'), function(outputHtml) {
        var match = parsing.parse(text);

        var options;

        if (match) {

            var that = this;

            var requireData = "newsletters";

            if (match[1]) {
                requireData += "?values=" + match[1];
            }

            getData(requireData, function (jsonString) {
                // check if the datasource is to be overridden
                if (that.dataSource != null) {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }
                }
                catch (e) {
                    options = false;
                }

                var insertOptions = "";

                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                if (options) {
                    if (options.length == 1) {
                        insertOptions += "[] " + options[0].value + " -> " + domObj.getAttribute('data-single-label') + " ";
                        domObj.removeChild(domObj.querySelector('label'));
                    }
                    else {
                        for (var i = 0; i < options.length; i++) {
                            insertOptions += "[] " + options[i].value + " -> " + options[i].label + " ";
                        }
                    }
                }

                if (insertOptions != "") {
                    if (match[2] == "*") {
                        domObj = container.firstChild;
                        domObj.setAttribute("data-required", "true");

                        // add a "required" class to the parent node
                        domObj.setAttribute("class", domObj.getAttribute("class") + " required");

                        outputHtml = container.innerHTML;

                        outputHtml = outputHtml.replace(" = []", "* = " + insertOptions);
                    }
                    else {
                        outputHtml = container.innerHTML;
                        outputHtml = outputHtml.replace("[]", insertOptions);
                    }
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });
}

function validate(context, err) {

    var value = get(context);

    var required = context.getAttribute("data-required") == "true";

    if (value) {

        var parent = context.closest('div[data-formid]');
        var emailContext = parent.querySelector('[data-module="email"]');

        var emailValid = emailContext.validate(true); // true);

        if (!emailValid) {
            return false;
        }

        //        THIS ISNT NEEDED ANY MORE BUT WE WONT BE CHOCKED IF THEY DECIDE TO USE IT AGAIN
        //        if (value !== null && consentContext) {
        //
        //            var consentEmail = consentContext.querySelector('[data-module="consentemail"]');
        //
        //            if (consentEmail) {
        //
        //                var consentEmailOk = consentEmail.validate();
        //
        //                if (!consentEmailOk) {
        //                    if (!consentContext.isOpen()) {
        //                        consentContext.toggleBox(null, true);
        //                        setTimeout(function() {
        //                            consentEmail.scrollIntoView({behavior: 'smooth'});
        //                        }, 400);
        //                    } else {
        //                        consentEmail.scrollIntoView({behavior: 'smooth'});
        //                    }
        //                    return Promise.resolve(false);
        //                }
        //
        //            }
        //        }

    }

    return validation.validate(value || '', required)
        .then(function(validationResult) {
            validationResult = !err ? validationResult : err;
            checkbox.validate(context);
            return validationResult.valid;
        });

}

function init( formRoot, meta, next ) {

    var select = formRoot.getAttribute('data-module-subscribe-select');
    var context = formRoot.querySelector('[data-module="subscribe"]');

    if( context && select ) {
        var inputs = context.querySelectorAll('input');

        if( select == 'all' ) {
            for(i = 0, ii = inputs.length; i < ii; i++) {
                inputs[i].checked = true;
            }
        }

    }

    if (context) {

        context.active = function() {
            var result = get(context);
            return !!result;
        }

    }

    next(formRoot);
}

function get(context) {
    return checkbox.get(context);
}

function reset(context) {
    checkbox.reset(context);
}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/subscribe/subscribe.js